import React from "react";

interface PageFooterProps {
  logo?: string | null;
  clientName?: string | null;
}

const PageFooter: React.FC<PageFooterProps> = ({ logo, clientName }) => {
  return (
    <footer
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        width: "100%",
        textAlign: "center",
        padding: "0.5rem 0",
        opacity: 0.7,
        pointerEvents: "none",
        zIndex: 40,
      }}
    >
      {logo && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "0.25rem",
          }}
        >
          <img
            src={logo}
            alt={`${clientName} logo`}
            style={{
              width: "7vw", // proportional width
              minWidth: "70px", // minimum width
              maxWidth: "120px", // optional max-width to prevent huge logos
              height: "auto", // preserve aspect ratio
              objectFit: "contain",
              margin: "0 auto",
              opacity: 0.5,
            }}
          />
        </div>
      )}
      <p style={{ color: "#6B7280", fontSize: "0.85rem", margin: 0 }}>
        © {new Date().getFullYear()} {clientName}
      </p>
      <p style={{ color: "#9CA3AF", fontSize: "0.85rem", margin: 0 }}>
        Powered by OurShopHub
      </p>
    </footer>
  );
};

export default PageFooter;
